import React from "react"
import Arrow from "../svgs/Arrow"

export const TextField = ({
  id,
  label,
  value,
  onChange,
  onBlur,
  onKeyDown,
  error,
  register,
  registerValue = null,
  required,
  last,
  className,
  type = "text",
  ...props
}) => {
  return (
    <div className={`relative flex flex-column flex-1`}>
      <input
        type={type}
        className={`border-2 border-gold relative w-full py-3 px-[18px] bg-white radius-none ${className}`}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        placeholder={label}
        required={required}
        autoComplete="off"
        {...register(id.toString(), registerValue)}
      />
      {error && <p className="text-xs italic text-red-500">{error}</p>}
    </div>
  )
}

export const SelectField = ({
  label,
  options,
  defaultValue = "default",
  disablePlaceholder = true,
  id,
  register,
}) => {
  return (
    <div className="relative max-md:!basis-full">
      <select
        defaultValue={defaultValue}
        className={`border-2 border-gold appearance-none py-3 pl-[18px] pr-[66px] w-full bg-white radius-none text-base cursor-pointer text-blue`}
        {...register(id.toString())}
      >
        <option
          value="default"
          disabled={disablePlaceholder}
          hidden={disablePlaceholder}
        >
          {label}
        </option>
        {options.map((option, index) => {
          // check if option is object
          const isObject = typeof option === "object"

          if (isObject)
            return (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            )
          return (
            <option key={index} value={option.toLowerCase()}>
              {option}
            </option>
          )
        })}
      </select>
      <div
        className={`text-gold absolute top-1 right-1 w-[46px] aspect-square flex justify-center items-center rounded-md [&_svg]:w-4 [&_svg]:fill-current cursor-pointer`}
      >
        <Arrow />
      </div>
    </div>
  )
}

export const SelectFieldSimple = ({
  label,
  options,
  defaultValue = "default",
  disablePlaceholder = true,
  id,
  onChange,
}) => {
  return (
    <div className={"relative max-md:!basis-full"}>
      <select
        defaultValue={defaultValue}
        className={`appearance-none py-3 pl-[18px] pr-[66px] w-full rounded-none text-base cursor-pointer text-blue border-2 border-gold`}
        onChange={onChange}
      >
        <option
          value="default"
          disabled={disablePlaceholder}
          hidden={disablePlaceholder}
        >
          {label}
        </option>
        {options.map((option, index) => {
          // check if option is object
          const isObject = typeof option === "object"

          if (isObject)
            return (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            )
          return <option key={index}>{option}</option>
        })}
      </select>
      <div
        className={`text-gold absolute top-1 right-1 w-[46px] aspect-square flex justify-center items-center rounded-md [&_svg]:w-4 [&_svg]:fill-current cursor-pointer`}
      >
        <Arrow />
      </div>
    </div>
  )
}
